import { render } from "./RenewModal.vue?vue&type=template&id=fd7e7a0c"
import script from "./RenewModal.vue?vue&type=script&lang=js"
export * from "./RenewModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__